import {Component, OnInit} from '@angular/core';
import {ViewerParameters} from "../../../../lib/bean/ViewerParameters";
import {DataRow} from "../../../../lib/bean/DataRow";
import {HttpClient} from "@angular/common/http";
import {Data} from "@angular/router";
import {AdditionalDataComputer} from "../../../../lib/compute/AdditionalDataCompute";
import {EnrichedDataRow} from "../../../../lib/bean/EnrichedDataRow";

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit {

  data: DataRow[];
  enrichedData: EnrichedDataRow[];
  parameters: ViewerParameters;
  computer: AdditionalDataComputer = new AdditionalDataComputer();

  constructor(private httpClient: HttpClient) {}

  ngOnInit(): void {
    const options = { responseType: 'text' as any };
    this.httpClient.get<any>("assets/input-measurements.csv", options)
      .toPromise()
      .then((value: any) => {

        this.data = new Array<DataRow>();

        let rowNumber = 0;
        for(let row of value.split("\n")) {

          if(row.length == 0)
            continue;

          let rowValues = row.split("\t");

          let rowBean = new DataRow();
          rowBean.rowNumber = rowNumber++;
          rowBean.timeJulian = parseFloat(rowValues[0].replace(',', ''));
          rowBean.timeJ2000 = parseFloat(rowValues[1]);
          rowBean.frequency = parseFloat(rowValues[2]);
          rowBean.dsn = parseFloat(rowValues[3]);

          this.data.push(rowBean);
        }
      });
  }

  onParameterChange(parameters: ViewerParameters): void {
    console.log("on parameter change: ", parameters);

    // Compute enriched data row
    this.enrichedData = this.data.map((row: DataRow) => this.computer.compute(parameters, row));
    this.parameters = parameters;
  }

}
